import { CASES } from './constants';

/**
 * Action to update shared sections in the store.
 *
 * This action is dispatched to update the shared sections state in the Redux store.
 * It takes a payload containing the new shared sections' data.
 *
 * @param {Object} payload - The new shared sections data to be stored.
 * @return {Object} The action object with type and payload.
 **/
export const updateSharedSections = (payload) => {
    return { type: CASES.UPDATE_SHARED_SECTIONS, payload };
};

/**
 * Action to update the shared sections filter form.
 *
 * This action is dispatched to update the filter form state in the Redux store.
 * It takes a key and data to update the specific field in the filter form.
 *
 * @param {string} key - The key of the filter form field to be updated.
 * @param {any} data - The new data to be set for the specified field.
 * @return {Object} The action object with type and payload.
 **/
export const updateSharedSectionsForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_SHARED_SECTIONS_FORM,
        payload: { key, data },
    };
};

/**
 * Action to clear the shared sections filter form.
 *
 * This action is dispatched to reset the filter form state in the Redux store.
 * It clears all the fields in the filter form.
 *
 * @returns {Object} The action object with type and payload.
 */
export const clearSharedSections = () => {
    return { type: CASES.CLEAR_SHARED_SECTIONS, payload: {} };
};
